import React from 'react'

export const InsertHeaderIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M28.75 27C28.75 27.9665 27.9665 28.75 27 28.75H5C4.0335 28.75 3.25 27.9665 3.25 27V5C3.25 4.0335 4.0335 3.25 5 3.25H27C27.9665 3.25 28.75 4.0335 28.75 5V27ZM16.75 4.75V9.25L27.25 9.25V5C27.25 4.86193 27.1381 4.75 27 4.75H16.75ZM4.75 9.25H15.25V4.75H5C4.86193 4.75 4.75 4.86193 4.75 5V9.25ZM4.75 27C4.75 27.1381 4.86193 27.25 5 27.25H15.25V10.75H4.75V27ZM27.25 27C27.25 27.1381 27.1381 27.25 27 27.25H16.75V10.75L27.25 10.75V27Z" fill="#475161" />
    </svg>
  )
}
